export const ZAI_CHAT_URL_BY_ENVIRONMENT = {
  local: 'http://localhost:3000',
  development: 'https://zai-chat.dev.insights.winnin.com',
  staging: 'https://zai-chat-staging.insights.winnin.com',
  production: 'https://chat.insights.winnin.com',
}
